import { ApiDOMError } from '@swagger-api/apidom-error';

/**
 * @public
 */
class JsonSchemaUriError extends ApiDOMError {}
export default JsonSchemaUriError;